import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import DEVICE_CONTEXT from "src/context/internal/device";
import { BadgeButton } from "src/components/base/badges/base";
import ReadOnlyACLs from "src/components/acl";

/**
 * The properties for {@link DeviceInboundACL}
 */
export type DeviceInboundACLProps = {};

/**
 * The view to display the Inbound ACLs of a device
 */
function DeviceInboundACL(props: DeviceInboundACLProps) {
    const ctx = React.useContext(DEVICE_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            {ctx.device.inbound_access_rules.tags.map((anchor) => (
                <div key={anchor.uuid} className={"flex flex-col gap-6 rounded border p-3 dark:border-zinc-700"}>
                    <BadgeButton
                        href={"/a/tags/$tagId/inbound-acls"}
                        params={{ tagId: anchor.uuid }}
                        className={"self-start"}
                        color={"blue"}
                    >
                        {`tag:${anchor.name}`}
                    </BadgeButton>

                    <ReadOnlyACLs rules={anchor.access_rules} dst={{ type: "Tag", value: anchor }} />
                </div>
            ))}

            {ctx.device.inbound_access_rules.groups.map((anchor) => (
                <div key={anchor.uuid} className={"flex flex-col gap-6 rounded border p-3 dark:border-zinc-700"}>
                    <BadgeButton
                        className={"self-start"}
                        color={"cyan"}
                        href={"/a/groups/$groupId/inbound-acls"}
                        params={{ groupId: anchor.uuid }}
                    >
                        {`group:${anchor.name}`}
                    </BadgeButton>

                    <ReadOnlyACLs
                        rules={anchor.access_rules}
                        dst={{ type: "Group", value: { ...anchor, external_id: "", internet: false } }}
                    />
                </div>
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/devices/$deviceId/_device/inbound-acls")({
    component: DeviceInboundACL,
});
